import { giphyBlack, giphyCharcoal, giphyDarkestGrey, giphyLightestGrey } from '@giphy/js-brand'
import styled from 'styled-components'
import { colorToRgba } from 'utils'

export const Checkerboard = styled.div`
    background-color: ${giphyDarkestGrey};
    background-image: linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%),
        linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%);
    background-size: 24px 24px;
    background-position: 0 0, 12px 12px;
    border-radius: inherit;

    &:before {
        background: linear-gradient(180deg, ${giphyBlack}, ${colorToRgba(giphyBlack, 0)});
        content: '';
        height: 80px;
        left: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        width: 100%;
    }
`

export const Container = styled.div`
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    position: relative;
`

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    padding: 30px;
`

export const Label = styled.h3`
    color: ${giphyLightestGrey};
    font-size: 16px;
    font-weight: bold;
    line-height: 18px;
    margin: 0 0 10px;
    text-align: left;

    > svg {
        display: inline-block;
        height: 18px;
        vertical-align: top;
        width: auto;

        &:first-child {
            margin-right: 8px;
        }

        &:last-child {
            margin-left: 8px;
        }

        path {
            fill: ${giphyCharcoal};
        }
    }
`

export const Toolbar = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    padding: 12px 15px;
    position: relative;
    width: 100%;
`
